import { render } from "./Pen.vue?vue&type=template&id=0ffae284"
import script from "./Pen.vue?vue&type=script&lang=js"
export * from "./Pen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Icons/Pen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ffae284"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ffae284', __exports__)) {
    api.reload('0ffae284', __exports__)
  }
  
  module.hot.accept("./Pen.vue?vue&type=template&id=0ffae284", () => {
    api.rerender('0ffae284', render)
  })

}


export default __exports__